import { gsap } from 'gsap';

export default function initializeButton() {
    const buttons = document.querySelectorAll('.button, .wp-element-button');

    buttons.forEach((button) => {
        const animateGradient = () => {
            console.log('hover')
            gsap.to(button, {
                duration: 0.5,
                background: 'linear-gradient(252deg, #CC2936 0%, #1A333C 100%)',
                ease: 'power2.inOut'
            });
        };

        const animateGradientReverse = () => {
            console.log('leave');
            gsap.to(button, {
                duration: 0.5,
                background: 'linear-gradient(252deg, #1A333C 0%, #CC2936 100%)',
                ease: 'power2.inOut'
            });
        };

        button.addEventListener('mouseenter', animateGradient);
        button.addEventListener('mouseleave', animateGradientReverse);
    });
}
